module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('span', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_c('radial-progress-bar', {
    attrs: {
      "diameter": 250,
      "animate-speed": 80,
      "completed-steps": _vm.completedSteps,
      "total-steps": _vm.totalSteps,
      "start-color": _vm.startColor,
      "stop-color": _vm.stopColor
    }
  }, [_c('p', {
    staticClass: "info-dl"
  }, [_vm._v("\n                " + _vm._s(_vm.txtSync) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "loader",
    class: {
      disabled: !_vm.loaderActif
    },
    attrs: {
      "id": "loader-2"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "textInfo"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.textInfo) + "\n            ")])])], 1), _vm._v(" "), (_vm.enErreur) ? _c('div', {
    staticClass: "actions-erreur"
  }, [_c('a', {
    staticClass: "btn btn-full",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reessayer($event)
      }
    }
  }, [_vm._v("Réessayer")]), _vm._v(" "), (_vm.retourDisponible) ? _c('a', {
    staticClass: "btn btn-wire",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.revenirApresEchec($event)
      }
    }
  }, [_vm._v("Retour à l'installation")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-wire",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allerAccueil($event)
      }
    }
  }, [_vm._v("Accueil")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8fff1a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Synchro.vue
// module id = 744
// module chunks = 0